module.exports = {"data":{"site":{"siteMetadata":{"title":"Vaaralav.com"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 156
// module chunks = 60335399758886 114276838955818